// test2147
(2147 && 0);
